module.exports = __webpack_public_path__ + "static/media/manage.9de784ab.svg";